export function scrollToElementById(id: string) {
  const section = document.getElementById(id)
  if (!section) return

  const rect = section.getBoundingClientRect()
  const body = document.documentElement || document.body
  const start = body.scrollTop
  const end = rect.top + body.scrollTop - 100
  const duration = 400

  let startTime: number | null = null

  function scrollAnimation(currentTime: number): void {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const scrollPosition = easeInOutQuad(
      timeElapsed,
      start,
      end - start,
      duration,
    )
    body.scrollTop = scrollPosition
    if (timeElapsed < duration) {
      requestAnimationFrame(scrollAnimation)
    }
  }

  function easeInOutQuad(t: number, b: number, c: number, d: number): number {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  requestAnimationFrame(scrollAnimation)
}
